export default __webpack_public_path__ + "static/media/IMG_9998.ac5a3cf2.jpeg";